'use strict';
import * as $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar from "./com.raquo.airstream.state.-Lazy-Derived-Var.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProcessor$0024 from "./com.raquo.laminar.keys.-Event-Processor$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm from "./dev.cheleb.scalamigen.-Form.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_package$package$$anon$2(to$4) {
  this.HN = null;
  this.HM = null;
  this.HN = to$4;
  $j_dev$002echeleb$002escalamigen$002e$002dForm.$f_Ldev_cheleb_scalamigen_Form__$init$__V(this);
}
export { $c_Ldev_cheleb_scalamigen_package$package$$anon$2 as $c_Ldev_cheleb_scalamigen_package$package$$anon$2 };
$p = $c_Ldev_cheleb_scalamigen_package$package$$anon$2.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_package$package$$anon$2;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_package$package$$anon$2() {
}
export { $h_Ldev_cheleb_scalamigen_package$package$$anon$2 as $h_Ldev_cheleb_scalamigen_package$package$$anon$2 };
$h_Ldev_cheleb_scalamigen_package$package$$anon$2.prototype = $p;
$p.dJ = (function() {
  return this.HM;
});
$p.dt = (function(x$1) {
  this.HM = x$1;
});
$p.du = (function(x$1) {
});
$p.dx = (function(label, required, factory) {
  return factory.cX(required, label);
});
$p.bt = (function(path, variable, factory, errorBus) {
  return $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$f_Lcom_raquo_laminar_nodes_ReactiveElement__amend__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveElement(factory.y1(), $j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.hv().kH(variable.a4()), new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_modifiers_EventListener(($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProcessor$0024.$m_Lcom_raquo_laminar_keys_EventProcessor$().bU($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.ir(), false, false)).js().il(this.HN), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((v$3) => {
    $j_com$002eraquo$002eairstream$002estate$002e$002dLazy$002dDerived$002dVar.$f_Lcom_raquo_airstream_state_Var__set__O__V(variable, v$3);
  })))]));
});
var $d_Ldev_cheleb_scalamigen_package$package$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_package$package$$anon$2, "dev.cheleb.scalamigen.package$package$$anon$2", ({
  jo: 1,
  a2: 1
}));
export { $d_Ldev_cheleb_scalamigen_package$package$$anon$2 as $d_Ldev_cheleb_scalamigen_package$package$$anon$2 };
